import * as React from "react";
import { SVGProps } from "react";
const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_558_21177)">
      <path
        d="M17.16 13.7485L17.0874 13.7702C16.9417 13.8131 16.7908 13.8358 16.6389 13.8374C15.978 13.8374 15.6054 13.391 15.8047 12.8396C15.952 12.4366 16.3366 12.0965 16.8068 11.9394C17.5348 11.674 18.044 11.0684 18.044 10.3631C18.044 9.41304 17.1199 8.64388 15.9802 8.64388C14.8405 8.64388 13.9175 9.41304 13.9175 10.3631V15.6368C13.9175 16.9043 13.182 18.0169 12.0824 18.6463C11.454 19.0043 10.7429 19.1918 10.0197 19.1901C7.87038 19.1901 6.12188 17.5965 6.12188 15.6368C6.12188 15.0128 6.29954 14.4267 6.61046 13.9175C7.09146 13.1267 7.89313 12.5233 8.85296 12.2481C9.01414 12.1968 9.18215 12.1702 9.35129 12.169C10.0143 12.169 10.3891 12.6175 10.1887 13.17C10.0522 13.546 9.68388 13.8688 9.25596 14.04C9.20513 14.057 9.15491 14.0758 9.10538 14.0963C8.42504 14.378 7.95596 14.9608 7.95596 15.6368C7.95596 16.5869 8.88004 17.356 10.0197 17.356C11.1594 17.356 12.0824 16.5869 12.0824 15.6368V10.3631C12.0824 9.09563 12.818 7.98304 13.9175 7.35363C14.5459 6.99564 15.257 6.80816 15.9802 6.80979C18.1295 6.80979 19.878 8.40338 19.878 10.3631C19.878 10.9871 19.7004 11.5732 19.3895 12.0824C18.9106 12.8689 18.1133 13.4712 17.16 13.7485ZM2.16663 13C2.16663 18.9832 7.01671 23.8333 13 23.8333C18.9832 23.8333 23.8333 18.9832 23.8333 13C23.8333 7.01671 18.9832 2.16663 13 2.16663C7.01671 2.16663 2.16663 7.01671 2.16663 13Z"
        fill="#13CB75"
      />
    </g>
    <defs>
      <clipPath id="clip0_558_21177">
        <rect width={26} height={26} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SVGComponent;
